<div class="table-container">
  <div class="table-container__actions">
    <mat-form-field class="package-search" appearance="outline" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput type="text" [(ngModel)]="searchInput" (keyup)="applySearch($any($event.target).value)" [placeholder]="'app.misc.search' | translate" />
      @if (searchInput) {
        <button type="button" mat-icon-button matSuffix aria-label="Clear" (click)="applySearch('')"><mat-icon>close</mat-icon></button>
      }
    </mat-form-field>
    <button type="button" mat-raised-button class="package-add-button" (click)="onAddCustomProduct()" [disabled]="!enableAdd">
      <mat-icon>add_circle</mat-icon><span>{{ "app.customProducts.addNewProduct" | translate }}</span>
    </button>
  </div>
  <div class="package-table-area">
    <div class="package-table-scroll">
  <mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="Pro_Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customProducts.name" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customProducts.name' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ row.Pro_Name }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customProducts.name" | translate }}</mat-label>
            <input
              matInput
              required
              maxlength="100"
              id="{{ row.Pro_Name }}"
              [(ngModel)]="row.Pro_Name"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.Pro_Name }}"
              autocomplete="customProducts"
              placeholder=" {{ 'app.customProducts.name' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Pro_Desc">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customProducts.description" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customProducts.description' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ row.Pro_Desc }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customProducts.description" | translate }}</mat-label>
            <input
              matInput
              maxlength="200"
              id="{{ row.Pro_Desc }}"
              [(ngModel)]="row.Pro_Desc"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.Pro_Desc }}"
              autocomplete="customProducts"
              placeholder=" {{ 'app.customProducts.description' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Pro_CON_Ref">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customProducts.countryOfOrigin" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customProducts.countryOfOrigin' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ getCountryName(row.Pro_CON_Ref) }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>
              {{ "app.shopifyOrders.details.shipperConsigneeDetails.countryName" | translate }}
            </mat-label>
            <mat-select [(value)]="row.Pro_CON_Ref">
              @for (country of countriesList; track country) {
                <mat-option [value]="country.CON_ID">
                  {{ country.CON_Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Pro_HSCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customProducts.hscode" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customProducts.hscode' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ row.Pro_HSCode }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customProducts.hscode" | translate }}</mat-label>
            <input
              matInput
              maxlength="100"
              id="{{ row.Pro_HSCode }}"
              [(ngModel)]="row.Pro_HSCode"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.Pro_HSCode }}"
              autocomplete="customProducts"
              placeholder="{{ 'app.customProducts.hscode' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Pro_Quantity">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customProducts.quantity" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customProducts.quantity' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ row.Pro_Quantity }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customProducts.quantity" | translate }}</mat-label>
            <input
              matInput
              id="{{ row.Pro_Quantity }}"
              [(ngModel)]="row.Pro_Quantity"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.Pro_Quantity }}"
              autocomplete="customProducts"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customProducts.quantity' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Pro_Weight">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customProducts.weight" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customProducts.weight' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ row.Pro_Weight }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customProducts.weight" | translate }}</mat-label>
            @if (row.UnitOfMeasure == 0) {
              <span matSuffix>&nbsp;kg&nbsp;</span>
            }
            @if (row.UnitOfMeasure == 1) {
              <span matSuffix>&nbsp;lbs&nbsp;</span>
            }
            <input
              matInput
              id="{{ row.Pro_Weight }}"
              [(ngModel)]="row.Pro_Weight"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.Pro_Weight }}"
              autocomplete="customProducts"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customProducts.weight' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Pro_UnitValue">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customProducts.unitvalue" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customProducts.unitvalue' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ row.Pro_UnitValue }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customProducts.unitvalue" | translate }}</mat-label>
            <input
              matInput
              id="{{ row.Pro_UnitValue }}"
              [(ngModel)]="row.Pro_UnitValue"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.Pro_UnitValue }}"
              autocomplete="customProducts"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customProducts.unitvalue' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="UnitOfMeasure">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.misc.unitOfMeasure" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.misc.unitOfMeasure' | translate">
        @if (row.Pro_Action != "UPDATE" && row.Pro_Action != "ADD") {
          <span class="dots">
            {{ getUOMName(row.UnitOfMeasure) }}
          </span>
        }
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label> {{ "app.misc.unitOfMeasure" | translate }}*</mat-label>
            <mat-select [(ngModel)]="row.UnitOfMeasure">
              @for (measure of measures; track measure) {
                <mat-option [value]="measure.code">{{ measure.name | translate }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
      <mat-cell *matCellDef="let row" class="package-actions-cell">
        @if (row.Pro_Action == "UPDATE" || row.Pro_Action == "ADD") {
          <div class="package-row-actions">
            <button type="button" mat-icon-button class="package-icon-button cancel" [matTooltip]="'app.misc.cancel' | translate" (click)="onCancel(row)"><mat-icon>close</mat-icon></button>
            <button type="button" mat-icon-button class="package-icon-button save" [matTooltip]="'app.misc.save' | translate" (click)="onSaveCustomProduct(row)"><mat-icon>save</mat-icon></button>
          </div>
        } @else {
          <div class="package-row-actions">
            <button type="button" mat-icon-button class="package-icon-button edit" [matTooltip]="'app.misc.edit' | translate" (click)="onModifyCustomProduct(row)"><mat-icon>edit</mat-icon></button>
            <button type="button" mat-icon-button class="package-icon-button delete" [matTooltip]="'app.misc.delete' | translate" (click)="onRemoveCustomProduct(row)"><mat-icon>delete</mat-icon></button>
          </div>
        }
      </mat-cell>
    </ng-container>

    <!-- Table header definition -->
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"> </mat-header-row>

    <!-- Table row definition -->
    <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
  </mat-table>
    </div>
    @if (!isProcessing && dataSource.filteredData.length === 0) {
      <div class="package-empty">
        <div class="package-empty-icon"><mat-icon>inventory_2</mat-icon></div>
        <h2>{{ "app.customProducts.title" | translate }}</h2>
        <p>{{ "app.misc.search" | translate }} — 0</p>
      </div>
    }
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>

<!-- The overlay to display when the page is processing something -->
@if (isProcessing) {
  <app-processing-overlay [message]="'app.misc.processing' | translate"> </app-processing-overlay>
}
